module.exports = __webpack_public_path__ + "static/media/epargnDH.1c7d9ff3.svg";